import { requestBudgetRouteProps } from 'src/navigation/routeProps'
import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import RecentUsersFullPaginatedDataReducer, {
  Actions as RecentUsersFullPaginatedDataActions,
  initialState as initialRecentUsersFullPaginatedDataState,
  RecentUsersFullPaginatedDataState,
} from 'src/redux/recentUsersFullPaginatedData.reducer'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'

export type RequestBudgetState = {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
  usersFullPaginatedData: UsersFullPaginatedDataState
  recentUsersFullPaginatedData: RecentUsersFullPaginatedDataState
}

export const initialState: RequestBudgetState = {
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
  recentUsersFullPaginatedData: initialRecentUsersFullPaginatedDataState,
}

export type Actions =
  | CreditCardsFullPaginatedDataActions
  | UsersFullPaginatedDataActions
  | RecentUsersFullPaginatedDataActions

const CoreRequestBudgetReducer = (
  state = initialState,
  action: Actions,
): RequestBudgetState => ({
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
  recentUsersFullPaginatedData: RecentUsersFullPaginatedDataReducer(
    state.recentUsersFullPaginatedData,
    action as RecentUsersFullPaginatedDataActions,
  ),
})

const RequestBudgetReducer = createFlyoutReducer(
  requestBudgetRouteProps,
  initialState,
  CoreRequestBudgetReducer,
)

export default RequestBudgetReducer
